import authentication from '../middleware/authentication'

const Dial = () => import(/* webpackChunkName: "static/js/chunks/callOut" */'../../views/callOut/Dial')

const callOutRoutes = [
  {
    path: '/callout/dial',
    component: Dial,
    name: 'Dial',
    hidden: true,
    meta: {
      middleware: authentication,
      layout: 'base'
    }
  }
]

export default callOutRoutes
